import { getProductInfo } from "src/utils/storage/product";
import { ProductKey } from "./config";
import { TFunction } from "i18next";

// 제외할 요금제
export const exceptPrice: any = {
  en: {
    wrapsody: ["free", "basicPlus", "plusPlus"],
    eco: ["free"],
  },
  ko: {
    wrapsody: ["free", "basicPlus", "plusPlus"],
    eco: ["free"],
  },
};
// 요금제 별로 사용할값
export interface IPayPlanInfo {
  WRAPSODY: {
    drive: {
      ko: {
        month: number;
        year: number;
      };
      en: {
        month: number;
        year: number;
      };
    };
    basic: {
      ko: {
        month: number;
        year: number;
      };
      en: {
        month: number;
        year: number;
      };
    };
    basicPlus: {
      ko: {
        month: number;
        year: number;
      };
      en: {
        month: number;
        year: number;
      };
    };
    plus: {
      ko: {
        month: number;
        year: number;
      };
      en: {
        month: number;
        year: number;
      };
    };
    plusPlus: {
      ko: {
        month: number;
        year: number;
      };
      en: {
        month: number;
        year: number;
      };
    };
  };
  WRAPSODY_ECO: {
    basic: {
      ko: {
        month: number;
        year: number;
      };
      en: {
        month: number;
        year: number;
      };
    };
    plus: {
      ko: {
        month: number;
        year: number;
      };
      en: {
        month: number;
        year: number;
      };
    };
  };
}
// 요금제 api 받아오는 정보
export type PriceListType = {
  key: string;
  name: string;
  serviceType: string;
  subTitle: string;
  subTitleDesc: string;
  subscription: string;
  featuresCnt: number;
  moreFeatures: number[];
  upcCnt: number;
};

interface IPriceList {
  wrapsody: PriceListType[];
  eco: PriceListType[];
}
export type ProductKeys = keyof IPriceList; // wrapsody, eco
// 모든 요금제
export const PRICE_LIST: any = ({
  t,
  lang = (t as any)?.i18n?.resolvedLanguage || (t as any)?.i18n?.language,
}: {
  t: TFunction;
  lang?: string;
}) => ({
  wrapsody: [
    {
      key: "free",
      name: t("subscriptionType.type.free_1"),
      serviceType: "TRIAL",
      subTitle: t("siteType.subscriptionType.subscriptionType_free"),
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.free", "Wrapsody"),
      featuresCnt: 2,
      moreFeatures: [],
      upcCnt: -1,
    },
    {
      key: "drive",
      name: "Basic",
      serviceType: "DRIVE",
      subTitle: t("subscriptionType.minimumPerPerson"),
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.drive"),
      featuresCnt: lang === "ko" ? 5 : 4,
      moreFeatures:
        lang === "ko"
          ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
          : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      // moreFeatures: [1, 2, 3, 4, 5, 9, 10, 11, 18, 19, 20],
      upcCnt: -1,
    },
    {
      key: "basic",
      name: "Standard",
      serviceType: "PAY_B",
      subTitle: t("subscriptionType.minimumPerPerson"),
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.wrapsodyBasic"),
      featuresCnt: lang === "ko" ? 4 : 4,
      moreFeatures:
        lang === "ko"
          ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
          : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      // moreFeatures: [1, 2, 3, 4, 5, 9, 10, 11, 18, 19, 20],
      upcCnt: -1,
    },
    {
      key: "basicPlus",
      name: "Standard Plus",
      serviceType: "PAY_C",
      subTitle: t("subscriptionType.minimumPerPerson"),
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.basicPlus"),
      featuresCnt: 3,
      moreFeatures: lang === "ko" ? [] : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      upcCnt: 3,
    },
    {
      key: "plus",
      name: "Enterprise",
      serviceType: "PAY_A",
      subTitle: t("subscriptionType.minimumPerPerson"),
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.enterprise"),
      featuresCnt: lang === "ko" ? 4 : 4,
      moreFeatures:
        lang === "ko"
          ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
          : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15],
      // moreFeatures: [1, 2, 3, 4, 5, 9, 11, 18, 19, 10, 20, 21, 22],
      upcCnt: -1,
    },
    {
      key: "plusPlus",
      name: "Enterprise Plus",
      serviceType: "PAY_D",
      subTitle: t("subscriptionType.minimumPerPerson"),
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.plusPlus"),
      featuresCnt: 3,
      moreFeatures:
        lang === "ko"
          ? [1, 2, 3, 4, 5, 9, 11, 18, 19, 10, 20, 21, 22]
          : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      upcCnt: 3,
    },
    {
      key: "premium",
      name: "Premium",
      serviceType: "PROMOTION",
      subTitle: t("subscriptionType.overThousandPerson"),
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.wrapsodyPremium"),
      featuresCnt: lang === "ko" ? 5 : 6,
      moreFeatures: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21,
      ],
      // moreFeatures: [
      //   1,
      //   2,
      //   3,
      //   4,
      //   5,
      //   9,
      //   11,
      //   18,
      //   19,
      //   10,
      //   20,
      //   21,
      //   22,
      //   23,
      //   24,
      //   25,
      //   26,
      //   27,
      //   28,
      //   29
      // ],
      upcCnt: 4,
    },
  ],
  eco: [
    {
      key: "free",
      name: t("subscriptionType.type.free_1"),
      serviceType: "TRIAL",
      subTitle: t("siteType.subscriptionType.subscriptionType_free"),
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.free", "Wrapsody eCo"),
      featuresCnt: 3,
      moreFeatures: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      upcCnt: -1,
    },
    {
      key: "basic",
      name: "Basic",
      serviceType: "PAY_B",
      subTitle: t("subscriptionType.monthlyPerPerson"),
      subTitleDesc: t("subscriptionType.annualPayment"),
      subscription: t("subscriptionType.description.basic"),
      featuresCnt: 6,
      moreFeatures: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      upcCnt: -1,
    },
    {
      key: "plus",
      name: "Plus",
      serviceType: "PAY_A",
      subTitle: t("subscriptionType.monthlyPerPerson"),
      subTitleDesc: t("subscriptionType.annualPayment"),
      subscription: t("subscriptionType.description.plus"),
      featuresCnt: 7,
      moreFeatures: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      upcCnt: 3,
    },
    {
      key: "premium",
      name: "Premium",
      serviceType: "PROMOTION",
      subTitle: " ",
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.premium"),
      featuresCnt: 7,
      moreFeatures: [
        3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      ],
      upcCnt: 4,
    },
  ],
  dspm: [
    {
      key: "free",
      name: t("subscriptionType.type.free_1"),
      serviceType: "TRIAL",
      subTitle: t("siteType.subscriptionType.subscriptionType_free"),
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.free", "Wrapsody eCo"),
      featuresCnt: 0,
      moreFeatures: [],
      upcCnt: -1,
    },
    {
      key: "basic",
      name: "Basic",
      serviceType: "PAY_B",
      subTitle: t("subscriptionType.monthlyPerPerson"),
      subTitleDesc: t("subscriptionType.annualPayment"),
      subscription: t("subscriptionType.description.basic"),
      featuresCnt: 6,
      moreFeatures: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      upcCnt: -1,
    },
    {
      key: "plus",
      name: "Plus",
      serviceType: "PAY_A",
      subTitle: t("subscriptionType.monthlyPerPerson"),
      subTitleDesc: t("subscriptionType.annualPayment"),
      subscription: t("subscriptionType.description.plus"),
      featuresCnt: 7,
      moreFeatures: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      upcCnt: 3,
    },
    {
      key: "premium",
      name: "Premium",
      serviceType: "PROMOTION",
      subTitle: " ",
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.premium"),
      featuresCnt: 7,
      moreFeatures: [
        3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      ],
      upcCnt: 4,
    },
  ],
  dsp: [
    {
      key: "premium",
      name: "Premium",
      serviceType: "PROMOTION",
      subTitle: " ",
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.premium"),
      featuresCnt: 0,
      moreFeatures: [],
      upcCnt: 0,
    },
  ],
  fireside: [
    {
      key: "premium",
      name: "Premium",
      serviceType: "PROMOTION",
      subTitle: " ",
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.premium"),
      featuresCnt: 0,
      moreFeatures: [],
      upcCnt: 0,
    },
  ],
  "mind-sat": [
    {
      key: "premium",
      name: "Premium",
      serviceType: "PROMOTION",
      subTitle: " ",
      subTitleDesc: " ",
      subscription: t("subscriptionType.description.premium"),
      featuresCnt: 0,
      moreFeatures: [],
      upcCnt: 0,
    },
  ],
});
// 제외된 요금제
export const EXCEPT_PRICE_LIST = exceptPrice;

// 현재 세션 스토리지에 저장된 제품키
const product = getProductInfo().key;

// export const exceptPriceList = PRICE_LIST[product].filter(
//   (item: any) => !exceptPrice[lang][product].includes(item.key)
// );

export const WrapsodyPriceNameMap: Record<string, string> = {
  drive: "Basic",
  basic: "Standard",
  basicPlus: "Standard Plus",
  plus: "Enterprise",
  plusPlus: "Enterprise Plus",
};
export const WrapsodyEcoPriceNameMap: Record<string, string> = {
  trial: "Trial",
  basic: "Basic",
  plus: "Plus",
};
export const priceNameMap = ({
  product,
  priceType,
}: {
  product: ProductKey;
  priceType: string;
}) => {
  if (product === "WRAPSODY") {
    return WrapsodyPriceNameMap[priceType];
  } else if (product === "WRAPSODY_ECO") {
    return WrapsodyEcoPriceNameMap[priceType];
  } else if (product === "DSPM") {
    return WrapsodyEcoPriceNameMap[priceType];
  } else if (product === "DSP") {
    return WrapsodyEcoPriceNameMap[priceType];
  }
};
export const VAT = 1.1; // 부가세 10%

// 요금제 기본 틀
export const payPlan = {
  WRAPSODY: {
    drive: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
    basic: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
    basicPlus: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
    plus: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
    plusPlus: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
  },
  WRAPSODY_ECO: {
    basic: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
    plus: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
  },
  DSPM: {
    basic: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
    plus: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
  },
  ENTERPRISE_DRM: {
    basic: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
    plus: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
  },
  FIRESIDE: {
    basic: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
    plus: {
      ko: {
        month: 0,
        year: 0,
      },
      en: {
        month: 0,
        year: 0,
      },
    },
  },
};
